import i18n from 'i18next'

export const trans = (text: string): string => {
  return i18n.t(text)
}

export const changeSupportedLanguage = (supportedLanguage: string): void => {
  // 'en-US' | 'pt-BR' | 'es-ES'
  localStorage.setItem('language', supportedLanguage)
  i18n.changeLanguage(supportedLanguage)
}
